import React from 'react';

import Heading from 'components/atoms/Heading';
import Icon from 'components/atoms/Icon';
import Text from 'components/atoms/Text';
import useMatchHeight from 'hooks/useMatchHeight';
import mapModifiers from 'utils/functions';

export interface SimpleReportCardProps {
  date: string;
  title: string[];
  subTitle: string;
  description: string;
  bntText: string;
  background: string;
  hasLogin?: boolean;
  handleDownload: () => void;
  handleLogin?: () => void;
  loginSSOLink?: string;
  isShowDate?: boolean;
  isShowDownload?: boolean;
}

const SimpleReportCard: React.FC<SimpleReportCardProps> = ({
  date,
  title,
  subTitle,
  description,
  bntText,
  background,
  hasLogin,
  handleDownload,
  handleLogin,
  isShowDate,
  isShowDownload,
}) => {
  useMatchHeight('.o-simpleReportCard_title');
  return (
    <div className="o-simpleReportCard" style={{ backgroundColor: background }}>
      <div className="o-simpleReportCard_info">
        {isShowDate && (
          <div className="o-simpleReportCard_date">
            <Text modifiers={['700', 'davysGrey', 'sm', 'center']}>{date}</Text>
          </div>
        )}
        <div className="o-simpleReportCard_title">
          <Heading
            type="h3"
            modifiers={['900', 'darkLiver', 'center', 'letterSpacing']}
          >
            {title.toString()}
          </Heading>
        </div>
        <div className="o-simpleReportCard_subTitle">
          <Text modifiers={['xl', 'darkLiver', 'letterSpacing', '700', 'center']}>
            {subTitle}
          </Text>
        </div>
      </div>
      <div className="o-simpleReportCard_description">
        <Text modifiers={['700', 'center', 'davysGrey', 'md']}>
          {description}
        </Text>
      </div>
      <div
        className={mapModifiers(
          'o-simpleReportCard_button',
          !hasLogin && 'hideButton',
        )}
      >
        {hasLogin && (
          <div className="o-simpleReportCard_login" onClick={handleLogin}>
            <Text modifiers={['500', 'darkLiver', 'md']}>{bntText}</Text>
          </div>
        )}
        {
          isShowDownload && (
            <div className="o-simpleReportCard_icon" onClick={handleDownload}>
              <Icon size="24" iconName="downLoad" />
            </div>
          )
        }
      </div>
    </div>
  );
};
SimpleReportCard.defaultProps = {
  hasLogin: false,
  isShowDate: undefined,
};

export default SimpleReportCard;
